import(/* webpackMode: "eager" */ "/codebuild/output/src122418740/src/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src122418740/src/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src122418740/src/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Montserrat\",\"arguments\":[{\"weight\":[\"300\",\"400\",\"500\",\"600\",\"700\"],\"style\":[\"normal\"],\"subsets\":[\"latin\"],\"display\":\"swap\",\"preload\":true}],\"variableName\":\"montserrat\"}");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src122418740/src/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["Modal"] */ "/codebuild/output/src122418740/src/src/ui/common/Modal/Modal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorButton"] */ "/codebuild/output/src122418740/src/src/ui/components/ErrorContent/ErrorButton.tsx");
